import { AGREEMENT_BULLETS as BULLETS } from '@generated/utils/terms';

export function AgreementPanel() {
  return (
    <div className="mt-5 rounded-lg border border-border bg-secondary/60 p-4 sm:p-5">
      <h3 className="font-[family-name:var(--font-heading)] text-sm font-medium text-foreground">
        What you are agreeing to
      </h3>
      <ul className="mt-3 space-y-2.5">
        {BULLETS.map((text) => (
          <li key={text} className="flex gap-2.5 text-xs leading-relaxed text-muted-foreground">
            <span className="mt-1.5 h-1 w-1 shrink-0 rounded-full bg-primary" aria-hidden="true" />
            <span>{text}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
